import script from "./PrivatePlanDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivatePlanDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PrivatePlanDetailsPopup.vue?vue&type=style&index=0&id=20184bc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20184bc3"]])

export default __exports__